module.exports = __webpack_public_path__ + "static/media/s5.70d203ca.png";